import { css } from '@emotion/react';

import { colors } from '../../styles/colors';
import { ZeeFontRegular } from '../../styles/font';
import { MediaBP as MQ } from '../../styles/mediaQuery';

export const footerMenu = css`
  margin: 0px 16px;
  text-align: center;
  ul {
    margin: 0;
    padding: 0;

    li {
      display: inline-block;
      padding: 8px 24px;
      position: relative;

      &:after {
        content: '';
        width: 1px;
        height: 13px;
        background: ${colors.PrimaryWhiteColorAlpha35};
        position: absolute;
        margin: auto;
        top: 0;
        right: 0;
        bottom: 0;
      }

      a,
      .globalDiv {
        color: ${colors.PrimaryWhiteColorAlpha70};
        ${ZeeFontRegular(12, 18)};
        cursor: pointer;
      }
      .consentSettingsStyle {
        color: ${colors.PrimaryWhiteColor};
        font-size: 0;
        cursor: pointer;
        border: 0;
        &:hover {
          background: none;
          &:after {
            color: ${colors.PurpleLight};
            background: none;
          }
        }
        &:after {
          ${ZeeFontRegular(12, 18)};
          cursor: pointer;
          color: ${colors.PrimaryWhiteColor};
          content: 'Consent Settings';
        }
      }

      &:last-child {
        &:after {
          display: none;
        }
      }
    }
  }
  ${MQ.MediaLg} {
    margin: 8px 0;
    ul {
      li {
        &:first-of-type {
          padding-left: 0;
        }
        a,
        .globalDiv {
          &:hover {
            color: ${colors.PurpleLight};
          }
        }
      }
    }
  }
  ${MQ.MediaSm} {
    padding-bottom: 0;
  }
`;

export const noSelect = css`
  user-select: none;
`;
